import React, { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const Redirect = () => {

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  // survey deep link url - /surveydetails/?id=6788d9a8417d70a755cbfbac

  useEffect(() => {
    if (location.pathname.includes("surveydetails")) {
      if (searchParams.get("id")) {
        navigate(`/survey-details/${searchParams.get("id")}`);
      } else {
        navigate('/#download');
      }
    } else {
      navigate('/#download');
    }
  }, [location]);

  return (
    <></>
  )
};

export default Redirect;